export function sbmPopUp() {
    'use strict';
    $ = jQuery;
    const layoutContainer = $('.layout-container');
    const sbmPopUpBox = $('header .sbm_popup');
    const sbmPopUpClose = $('header .sbm_popup .closing i');
    const mainHeader = $('header');
    if (sbmPopUpBox.length > 0) {
        const timeToShow = sbmPopUpBox.attr('data-time');
        const isCookie = Cookies.get('hideSbmPopup');
        if (undefined === isCookie) {
            if (!sbmPopUpBox.hasClass('show')) {
                setTimeout(function () {
                    sbmPopUpBox.addClass('show');
                    mainHeader.addClass('popup_enabled');
                    layoutContainer.addClass('popup_enabled');
                    sbmPopUpBox.css('height', layoutContainer.outerHeight());
                }, timeToShow);
                sbmPopUpClose.on('click', function () {
                    sbmPopUpBox.remove();
                    mainHeader.removeClass('popup_enabled');
                    layoutContainer.removeClass('popup_enabled');
                    layoutContainer.css('padding-top', mainHeader.outerHeight() - 1);
                    Cookies.set('hideSbmPopup', 'yes', {expires: 30});
                });
            }
        }
    }
}